/* eslint-disable react/display-name */
import * as React from 'react';
import { createLocators } from '@u1/locators';
import useStyles from './InputText.styles';

import clsx from 'clsx';

export type InputRef = HTMLInputElement;
export interface IInputTextProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  /**
   * Input value for controlled element
   */
  value?: string | number;
  /**
   * Default string displayed when input is empty
   */
  placeholder?: string;
  /**
   * OnChange callback
   */
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  /**
   * Background variant
   */
  variant?: 'white' | 'gray';
  /**
   * Is input reuired
   * @default false
   */
  required?: boolean;
  /**
   * Is input invalid
   * @default false
   */
  invalid?: boolean;
  /**
   * Is input disabled
   * @default false
   */
  disabled?: boolean;
  /**
   * Escape hatch to add styles to the input
   */
  _UNSAFE_classname?: string;
}

export const inputTextLocators = createLocators({
  name: 'InputText',
  componentLocators: ['input'],
});
const { locators } = inputTextLocators();

const InputText = React.forwardRef<InputRef, IInputTextProps>(
  (
    {
      name,
      value,
      onChange,
      invalid,
      placeholder,
      disabled,
      defaultValue,
      variant = 'white',
      type = 'text',
      _UNSAFE_classname,
      ...props
    },
    ref,
  ) => {
    const classes = useStyles();

    return (
      <input
        {...props}
        {...locators.input({ disabled, name })}
        ref={ref}
        name={name}
        className={clsx(classes.input, _UNSAFE_classname, {
          [classes.error]: invalid,
          [classes.gray]: variant === 'gray',
        })}
        type={type}
        disabled={disabled}
        defaultValue={defaultValue}
        onChange={onChange}
        value={value}
        placeholder={placeholder}
      />
    );
  },
);

export default InputText;
